import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import esriId from "@arcgis/core/identity/IdentityManager";
import Portal from "@arcgis/core/portal/Portal";

export default class AuthManager {
  constructor(appId, portalUrl, jsapiUrl, jsapiV4, loginWithPopup, use3D) {
    this.appId = appId;
    this.portalUrl = portalUrl;
    this.loginWithPopup = loginWithPopup;
    this.userCredential = null;
  }

  startup = () => {
    //Used from App.jsx
    return new Promise((resolve, reject) => {

            this.idManager = esriId;
            this.idManager.useSignInPage = !this.loginWithPopup;
            this.oAuthInfo = new OAuthInfo({ appId: this.appId, portalUrl: this.portalUrl, popup: this.loginWithPopup });
            this.idManager.registerOAuthInfos([this.oAuthInfo]);
            resolve();
         
        })
        .catch((err) => { console.log(err); });
  }

  login = () => {
    //Used from Login.ts
    return new Promise((resolve, reject) => {
      this.checkLogin().then(
        success => {
          this.getUser().then(resolve, reject);
        },
        failed => {
          this.doLogin().then(user => resolve(user), error => reject(error));
        }
      )
    });
  }

  logout = () => {
    //Being used in App.jsx
    return new Promise((resolve, reject) => {
      this.idManager.destroyCredentials();

      window.location.reload();
    });
  }

  checkLogin = () => {
    //Used in this file and in App.jsx
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.checkSignInStatus(sharingUrl)
        .then(credential => {
          this.userCredential = credential;
          this.getUser().then(resolve, reject);
        })
        .catch(() => {
          reject('User is not logged in');
        });
    });
  }

  doLogin = () => {
    //Being used in this file
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.getCredential(sharingUrl, { oAuthPopupConfirmation: false }).then((credential) => {
        this.getUser().then(resolve, reject);
      }).catch(err => { reject(); });
    });
  }

  getUser = () => {
    //Being used in this file
    return new Promise((resolve, reject) => {

        let portal = new Portal({
          url: this.portalUrl,
          authMode: "immediate"
        });
        portal.load().then(() => {
          this.user = portal.user;
          const obj = {
            user: portal.user,
            token: this.userCredential.token
          }
          resolve(obj);
        }).catch(err => { reject(); });

    });
  }

}
